<template>
  <div class="side-frame-warning">
    <span style="font-size: 15px; color: #606266">
      {{ $l('INDEX.group_booking_info') || '订舱信息' }}
    </span>
    <el-divider direction="vertical" v-if="!disabled && shipmentStatus != 'M'"></el-divider>
    <b-button-group size="sm">
      <b-button
        class="mr-2"
        variant="outline-success"
        v-if="!disabled && shipmentStatus == 'B'"
        @click="$emit('openEditBaseDialog', { type: 'add' })"
      >
        <i class="el-icon-plus" />
        {{ $l('INDEX.btn_add') || '新增' }}
      </b-button>
      <b-button
        class="mr-2"
        variant="outline-danger"
        v-if="!disabled && shipmentStatus == 'B'"
        @click="$emit('batchDel')"
      >
        <i class="el-icon-delete"></i>
        {{ $l('INDEX.btn_delete') || '删除' }}
      </b-button>
      <b-button
        variant="outline-success"
        v-if="!disabled && shipmentStatus != 'M'"
        @click="$emit('openBatchEditDialog')"
      >
        <i class="el-icon-edit" />
        {{ $l('INDEX.btn_tips_edit') || '编辑' }}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    shipmentStatus: { type: String, default: '' },
  },
}
</script>
